import styled from "styled-components";
import theme from "./../../styles/theme"


export const TrocSection = styled.section`
  font-family: ${theme.fonts.montSerrat};
  padding: 0px 0px 40px;

  @media (max-width:  ${theme.breakpoints.medium}){
    padding: 50px 0 40px;
  }
`;

export const Trocvideo = styled.div`
  background: linear-gradient(180deg,rgb(255 255 255 / 0%) 70%,rgb(0 0 0) 0%);
  @media (max-width: ${theme.breakpoints.medium}){
    margin-bottom: -2px;
    background:linear-gradient(180deg,rgb(255 255 255 / 0%) 60%,rgb(0 0 0) 0%);
    iframe{
      width: 335px;
      height: 150px;
    }
  }
`;

export const TrocLogo = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-color: black;
  background: linear-gradient(180deg,rgb(255 255 255 / 0%) 70%,rgb(0 0 0) 0%);
  gap: 50px;

  @media (max-width:  ${theme.breakpoints.medium}) {
    flex-direction: column;

    gap: 0px;

    img{
      width: 100%;
    }
  }
`;

export const TrocBoxTitle = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  gap: 50px;
  padding-bottom: 70px;
  margin-left: -100px;
  background-color: black;

  div{
    width: 20%;
    img{
      width: 211px!important;
    }
  }

  @media (max-width:  ${theme.breakpoints.medium}){
    padding: 60px 40px 40px;
    flex-direction: column;
    margin: 0;
    gap: 0;

    div{
      width: 40%;
    }
  }
`;

export const TrocTitle = styled.h3`
  color: white;
  font-style: normal;
  font-weight: 500 !important;
  font-size: ${theme.fontSizes.medium};
  line-height: 26px;
  text-align: initial;

  @media (max-width:  ${theme.breakpoints.medium}){
    font-size: ${theme.fontSizes.small};
    line-height: 22px;
    text-align: initial;
    padding-top: 20px;
  }
`;

export const TrocBackgoud = styled.div`
  height: 50px;
  background: #DD5331;
`;

export const TrocWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: 80px 80px 30px 80px;
  gap: 140px;

  @media (max-width:  ${theme.breakpoints.medium}){
    padding: 20px 40px;
  }
`;

export const TrocBoxDescription = styled.div`
  width: 100%;
`;

export const TrocBoxImgs = styled.div`
  display: flex;
  flex-direction: column;
  width: 70%;
  height: 100%;
  gap: 10px;
  border: 1px solid rgba(225, 225, 225, 0.3);
  box-sizing: border-box;
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.01), 0px 4px 8px rgba(0, 0, 0, 0.02), 0px 1px 12px rgba(0, 0, 0, 0.12);
  border-radius: 5px;
  padding: 10px;

  @media (max-width:  ${theme.breakpoints.medium}){
    display: none;
  }
`;
export const TrocText = styled.p`
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: ${theme.colors.gray};
  text-align: left;
  padding-bottom: 15px;
`;

export const TrocMore = styled.p`
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: ${theme.colors.gray};
`;

export const TrocBoxLink = styled.div`
  display: flex;
  gap: 5px;
  p{
    padding-bottom: 0;
  }
`;

export const TrocBoxLinkText = styled.p`
  font-style: normal;
  font-weight: ${theme.fontWeights.bold};
  font-size: 16px;
  line-height: 20px;
  color: ${theme.colors.gray};
`;

export const TrocBoxLinkbtn = styled.a`
  font-style: normal;
  font-weight: ${theme.fontWeights.bold};
  font-size: 16px;
  line-height: 20px;
  color: #DD5331 !important;
`;
